import React, { useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import Facebook from "../../Assets/homepage_icons/Facebook.svg";
import Instagram from "../../Assets/homepage_icons/Instagram.svg";
import LinkedIn from "../../Assets/homepage_icons/LinkedIn.svg";
import Reddit from "../../Assets/homepage_icons/Reddit.svg";
import Twitter from "../../Assets/homepage_icons/Twitter.svg";
import Youtube from "../../Assets/homepage_icons/Youtube.svg";
import Logo from "../../Assets/logo.png";
import FacebookOrange from "../../Assets/homepage_icons/FacebookOrange.svg";
import InstagramOrange from "../../Assets/homepage_icons/InstagramOrange.svg";
import LinkedInOrange from "../../Assets/homepage_icons/LinkedInOrange.svg";
import RedditOrange from "../../Assets/homepage_icons/RedditOrange.svg";
import TwitterOrange from "../../Assets/homepage_icons/TwitterOrange.svg";
import YoutubeOrange from "../../Assets/homepage_icons/YoutubeOrange.svg";
import FacebookPlaceholder from '../../Assets/homepage_icons/FacebookPlaceholder.png';
import InstagramPlaceholder from '../../Assets/homepage_icons/InstagramPlaceholder.png';
import LinkedInPlaceholder from '../../Assets/homepage_icons/LinkedInPlaceholder.jpg';
import RedditPlaceholder from '../../Assets/homepage_icons/RedditPlaceholder.png';
import TwitterPlaceholder from '../../Assets/homepage_icons/TwitterPlaceholder.png';
import YoutubePlaceholder from '../../Assets/homepage_icons/YoutubePlaceholder.png';


const Footer = ({ isCompanyLogoRequired = true }) => {

    const Navigate = useNavigate();
    const location = useLocation();
    const isPricingPage = location.pathname === "/pricing";

    const socialLinks = [
        { name: "Facebook", icon: 'https://blobtalentai.blob.core.windows.net/storagezepcruit/statics/Facebook.svg', hover: FacebookOrange, placeholder:FacebookPlaceholder , url: "https://www.facebook.com/share/1BTMSRM7FW/?mibextid=wwXIfr" },
        { name: "Instagram", icon: 'https://blobtalentai.blob.core.windows.net/storagezepcruit/statics/Instagram.svg', hover: InstagramOrange, placeholder:InstagramPlaceholder, url: "https://www.instagram.com/zepcruit/" },
        { name: "LinkedIn", icon: 'https://blobtalentai.blob.core.windows.net/storagezepcruit/statics/LinkedIn.svg', hover: LinkedInOrange,placeholder:LinkedInPlaceholder, url: "https://www.linkedin.com/company/zepcruit/" },
        { name: "Twitter", icon: 'https://blobtalentai.blob.core.windows.net/storagezepcruit/statics/Twitter.svg', hover: TwitterOrange,placeholder:TwitterPlaceholder, url: "https://x.com/zepcruit?s=21&t=88zqxWeKmrRr43betiZj-g" },
        { name: "Reddit", icon: 'https://blobtalentai.blob.core.windows.net/storagezepcruit/statics/Reddit.svg', hover: RedditOrange,placeholder:RedditPlaceholder, url: "https://www.reddit.com/r/Zepcruit/s/T5DrcUNKFk" },
        { name: "Youtube", icon: 'https://blobtalentai.blob.core.windows.net/storagezepcruit/statics/Youtube.svg', hover: YoutubeOrange,placeholder:YoutubePlaceholder, url: "https://youtube.com/@zepcruit?si=dFF4B-bATGsbJECx" }
    ];

    const [hoveredIndex, setHoveredIndex] = useState(null);



    return (
        <div className= {` px-4 md:px-12 xl:px-24 py-10 ${isPricingPage ? 'bg-[#F7F7F5]' : ''} `}>
            {/* Main Footer Section */}
            <footer className="flex flex-col md:flex-row items-center justify-between ">
                {/* Left Side - Logo */}
                {
                    isCompanyLogoRequired && (<div>
                        <img src={Logo} alt="Logo" className="w-32 xl:w-44 h-auto" />
                    </div>)
                }


                {/* Right Side - Social Media Icons */}
                <div className="flex flex-col items-center md:mt-0 mt-4">
                    <div className="flex space-x-4">
                        {socialLinks.map((item, index) => (
                            <a
                                key={index}
                                href={item.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                            >
                                <img
                                    src={hoveredIndex === index ? item.hover : item.icon}
                                    // placeholderSrc={item.placeholder}
                                    loading="lazy"
                                    alt={`${item.name} Icon`}
                                    className="w-8 h-8 transition duration-300"
                                />
                            </a>
                        ))}
                    </div>
                </div>

            </footer>

            {/* Horizontal Line */}
            <hr className="w-full border-gray-700 md:mt-2 mt-4" />

            {/* Secondary Footer Section */}
            <div className="flex flex-col md:flex-row items-center justify-between md:mt-2 mt-4">
                {/* Left Side - Links */}
                <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-6 xl:text-lg md:text-md whitespace-nowrap text-center sm:text-left">
                    <div className="flex flex-row space-x-4">
                        <a className="hover:underline cursor-pointer" onClick={() => Navigate("/privacy-policy")}>Privacy Policy</a>
                        <a className="hover:underline cursor-pointer" onClick={() => Navigate("/terms-and-conditions")}>Terms & Conditions</a>
                        <a className="hover:underline cursor-pointer" onClick={() => Navigate("/our-teams")}>Contact Us</a>
                    </div>
                </div>


                {/* Right Side - Copyright Notice */}
                <div className="mt-6 md:mt-0 xl:text-md md:text-sm text-xs text-gray-700">
                    <p>© Copyright 2025 Zepcruit. All Rights Reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default Footer;
